<div *ngIf="hasCardToDisplay" class="cardContainer">
    <ng-container *ngIf="isInprogress; else content">
        <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
        ></span>
        <span>{{ 'common.working' | translate }}...</span>
    </ng-container>

    <ng-template #content>
        <div *ngIf="customerCard" class="card">
            <span class="title">
                {{ customerCard.providerName }}&nbsp;{{ 'common.card' | translate }}
            </span>
            <div class="barcode">
                <svg #barcodeSvg></svg>
                <span class="data">{{ customerCard.barcodeData }}</span>
            </div>
        </div>
    </ng-template>
</div>
